<script lang="ts">
  import type {SuggestionRequest} from "./types/global";
  import {isFocus, isSuggestOpen, target, value} from "./store/SearchfieldStore";
  import {isActive} from "./store/SubmitStore";
  import SearchLayer from "./components/searchLayer/SearchLayer.svelte";
  import SuggestLayer from "./components/suggestLayer/SuggestLayer.svelte";
  import {IndexControllerService} from "./generated";
  import {FindQa, SqrlQaId} from "./constants/squirrel";
  import {keywords, original} from "./store/SuggestionStore";
  import {sendTrackingLabelOnFocus} from "./store/TrackingStore";
  import {eventQBus} from "@otto-ec/event-q-bus";
  import {encodedHistory, isEmpty, submitHistory} from "./store/HistoryStore";
  import {navSlider} from "./components/suggestLayer/navSlider/NavSlider";
  import {tracking} from "./tracking/Tracking";
  import {tlSearchBoxActionCharacter} from "./tracking/labels/SearchBoxAction";
  import {tlSuggestMethodAction} from "./tracking/labels/SuggestMethodAction";
  import {SQRL_EVENT} from "./constants/ftfindEvents";
  import {SanHeader} from "./constants/sanHeader";
  import {eventLoader} from "@otto-ec/global-resources/event-loader";
  import {onDestroy} from "svelte";

  const bus = eventQBus();
  let searchbarWrapper: HTMLDivElement;
  let currentRequest: SuggestionRequest = null;
  bus.onModuleLoaded("squirrel.stomachshop.searchbar", ["reptile.turtle.body-js"], () => {
    const searchterm = document.querySelector("#reptile-searchterm")?.getAttribute("data-searchterm");
    if (searchterm) {
      $sendTrackingLabelOnFocus = false;
      tlSearchBoxActionCharacter.setIsTrackable(false);
      $value = searchterm
    }
  });

  /*                                                                                     */
  eventLoader.onAllPreloadScriptsLoaded(120,async () => {
    submitHistory.reInitialize();
    /*                     */
    currentRequest = IndexControllerService.query($value, $isEmpty ? undefined : encodedHistory(), $value.length);
    await resolveCurrentRequest(true);
  });

  let firstFocus = true;
  const unsubscribeFocus = isFocus.subscribe((isFocusValue) => {
    if (firstFocus) {
      firstFocus = false;
      return;
    }
    if (!isFocusValue) {
      tracking.trackSubmitEvent({san_Header: SanHeader.CANCEL});
    }
  });
  const unsubscribeValue = value.subscribe((value) => {
    if (!value) {
      tlSearchBoxActionCharacter.setIsTrackable(true);
    } else if (tlSearchBoxActionCharacter.isTrackable() && value && $isActive) {
      tracking.trackSubmitEvent(tlSearchBoxActionCharacter.data);
      tlSearchBoxActionCharacter.setIsTrackable(false);
    }
  });


  async function resolveCurrentRequest(initial: boolean = false) {
    const response = await currentRequest;
    $target = response?.original.target;
    $keywords = response?.keywords || [];
    $original = response?.original || [];

    const trackingData = tlSuggestMethodAction.data;
    if (Object.keys(trackingData).length && !initial) {
      tracking.trackSubmitEvent(trackingData)
    }
  }

  export function focusOut(node: Node) {
    const handleFocus = (event: FocusEvent) => {
      if (
        node &&
        !node.contains(event.target as Node) &&
        !event.defaultPrevented &&
        $isSuggestOpen
      ) {
        $isSuggestOpen = false;
        $sendTrackingLabelOnFocus = !$value;
      }
    };

    document.addEventListener("focusin", handleFocus, true);
    document.addEventListener("click", handleFocus, true);
    return {
      destroy() {
        document.removeEventListener("focusin", handleFocus, true);
        document.removeEventListener("click", handleFocus, true);
      }
    };
  }

  function sendRequest(term: string) {
    const selectionStart: number | null | undefined = searchbarWrapper?.querySelector("input")?.selectionStart
    let cursorPosition: number;
    if (selectionStart && selectionStart <= term.length) {
      cursorPosition = selectionStart;
    } else {
      cursorPosition = term.length;
    }
    currentRequest = IndexControllerService.query(term, $isEmpty ? undefined : encodedHistory(), cursorPosition);
    resolveCurrentRequest();
  }

  bus.on(SQRL_EVENT.SEARCH_FOCUS, (mergeContext) => {
    navSlider.onMergeEventContext(mergeContext)
  });

  onDestroy(() => {
    unsubscribeFocus();
    unsubscribeValue();
  });
</script>

<div class="squirrel_searchbarWrapper js_squirrel_searchbarWrapper"
     class:squirrel_active={$isSuggestOpen}
     data-qa-id={SqrlQaId.WRAPPER}
     data-qa={FindQa.WRAPPER}
     bind:this={searchbarWrapper}
     use:focusOut>
    <SearchLayer on:sendRequest={(e) =>sendRequest(e.detail.term)}/>
    {#if $isSuggestOpen}
        <SuggestLayer on:sendRequest={(e) =>sendRequest(e.detail.term)}/>
    {/if}
</div>

<style lang="scss">
  @use "~@otto-ec/global-frontend-settings/scss/breakpoint" as breakpoint;
  @use "~@otto-ec/global-frontend-settings/scss/pl_variables" as pl_variables;

  .squirrel_searchbarWrapper {
    width: 100%;
    background-color: pl_variables.$pl_color-white100;

    @include breakpoint.from-l($to: false) {
      padding: 16px 16px 0;
      border-radius: 8px 8px 0 0;
      max-width: 500px;
      border: 1px solid #fff;
    }

    &.squirrel_active {
      @include breakpoint.from-l($to: false) {
        position: absolute;
        padding: 16px;
        z-index: 102;
        border: 1px solid #c4c4c4;
      }
    }
  }
</style>
